<section
	class="surface error-page"
	role="main"
	aria-labelledby="error-page-title"
	aria-describedby="error-page-description"
>
	<div class="error-page-content" role="alert" aria-live="assertive" aria-atomic="true">
		<h1 id="error-page-title">{{ 'error_page.title' | transloco }}</h1>
		<p id="error-page-description">
			{{ 'error_page.body' | transloco }}
		</p>
		<div class="error-page-actions">
			<lvr-button variant="primary" [label]="'error_page.back_to_overview' | transloco" (clicked)="goToOverview()">
			</lvr-button>
			<lvr-button variant="secondary" [label]="'error_page.report_issue' | transloco" (clicked)="requestBugReport()">
			</lvr-button>
		</div>
	</div>
	<img src="/image/no_go_graphic.png" alt="" aria-hidden="true" />
</section>
